import { useContext, useEffect, useState } from "react";
import { BrandTheme, FormData, Locale, QuestThemeData, QuizProps, Translation } from "./QuizTypes";
import QuestContext from "../../QuestWrapper";
import ResultPopup from "./ResultPopup";
import './Quiz.css';
import { PrimaryButton } from "../../Modules/PrimaryButton";
import General from "../../../general";
import Cookies from "universal-cookie";
import QuizApi from "./QuizApi";
import MultiChoice from "./MultiChoice";
import SingleChoice from "./SingleChoice";
import { BackIcon, CloseIcon } from "./SVG";
const Quiz: React.FC<QuizProps> = ({
    userId,
    token,
    questId: campaignId,
    // uniqueUserId,
    // uniqueEmailId,
    showFooter,
    footerText,
    footerLink,
    styleConfig,
    Quiz,
    setQuiz,
    // functionOnSubmit,
    setQuestions,
    variation,
    isV1Api,
    IconColor,
    // isAccumulateAndSelf,
    optionsHeader,
    optionRankFormat,
    unselectedSvg,
    selectedSvg,
    onClose,
    isQuizOverview,
    // functionOnExceededRetryCount,
    // functionOnSuccessfulSubmit,
    ResultPopupCloseIcon,
    isQuizOverviewTitle,
    formDataOffline,
    optionCheckboxes
}) => {
    const { apiKey, apiSecret, entityId, apiType, themeConfig } = useContext(
        QuestContext.Context
    );
    let quizApi = new QuizApi(apiType);
    let GeneralFunctions = new General("mixpanel", apiType);
    const newId = isV1Api ? "criteriaId" : "actionId";

    const [questThemeData] = useState<QuestThemeData>({
        accentColor: "",
        theme: "",
        borderRadius: "",
        buttonColor: "",
        images: [],
    });

    const urlParams = new URLSearchParams(window.location.search);
    const localeCode = urlParams.get("localeCode");
    const [locales, setLocales] = useState<Locale[]>([]);
    const [translatedData, setTranslatedData] = useState<Translation[]>([]);

    const [isResultPopup, setIsResultPopup] = useState(false);
    const cookies = new Cookies();
    const [answer, setAnswer] = useState<Record<string, string | Array<string>>>(
        {}
    );
    const [campaignVariationId, setCampaignVariationId] = useState("");

    const [formdata, setFormdata] = useState<FormData[] | []>(formDataOffline || []);
    const [formDataSecondary, setFormDataSecondary] = useState<FormData[] | []>(
        formDataOffline || []
    );
    const [currentSection, setCurrentSection] = useState(0);

    const [totalQuestions, setTotalQuestions] = useState<number>(formDataOffline?.length || 0);

    const [translatedButton, setTranslatedButton] = useState("Submit");

    const [quizSummary, setQuizSummary] = useState<any>([]);
    const [correctQuestions, setCorrectQuestions] = useState<number>(0);
    const [expectedCorrectedAnswers, setExpectedCorrectedAnswers] = useState(false);

    const getPhraseData = async () => {
        try {
            const filteredLocales = await quizApi.fetchLocalesAndTranslations();
            setLocales(filteredLocales);

            const translationResponses = await Promise.all(
                filteredLocales.map((locale) =>
                    quizApi.getTranslation(entityId, locale)
                )
            );

            const allTranslations = translationResponses.flat();

            allTranslations.forEach((tr: any) => {
                if (tr.key === "Submit" && tr.name === localeCode) {
                    setTranslatedButton(tr.message);
                }
            });

            setTranslatedData(allTranslations);
            return allTranslations;
        } catch (error) {
            console.error("Error fetching phrase data:", error);
        }
    };

    useEffect(() => {
        setFormdata(formDataOffline || []);
        setTotalQuestions(formDataOffline?.length || 0);
    }, [formDataOffline])

    useEffect(() => {
        // quizApi.handleUserMetrics({
        //     entityId,
        //     campaignId: campaignId || '',
        //     uniqueUserId,
        //     uniqueEmailId,
        //     externalUserId: cookies.get("externalUserId"),
        //     questUserId: cookies.get("questUserId"),
        //     questUserToken: cookies.get("questUserToken"),
        //     headers: {
        //         apiKey,
        //         apisecret: apiSecret,
        //         userId,
        //         token,
        //     },
        // });

        const getQuestData = async () => {
            try {
                let res = await quizApi.getQuestDataV2({
                    headers: {
                        apiKey,
                        apisecret: apiSecret,
                        userId,
                        token,
                    },
                    campaignId: campaignId || '',
                    entityId,
                    variation,
                });
                setQuestions?.(res.data.eligibilityCriterias.length);
                let actions = res.actions.map((action: any) => {
                    return {
                        type: action?.actionType,
                        question: action?.title,
                        options: action?.options || [],
                        actionId: action?.actionId,
                        required: action?.isRequired,
                        placeholder: action?.metadata?.placeholder,
                        preventFutureSelection: action?.metadata?.preventFutureSelection,
                        preventPastSelection: action?.metadata?.preventPastSelection,
                    };
                });

                setTotalQuestions(res.actions.length);

                if (actions?.length > 0) {
                    setFormdata([...actions]);
                } else {
                    setFormdata([]);
                }
                setCampaignVariationId(res.data.campaignVariationId);
            } catch (error) {
                console.error("Error fetching quest data:", error);
                GeneralFunctions.captureSentryException(error);
            }
        }

        const getQuestDataV1 = async () => {
            try {
                let transition = await getPhraseData();
                let res = await quizApi.getQuestDataV1({
                    headers: {
                        apiKey,
                        apisecret: apiSecret,
                        userId,
                        token,
                    },
                    campaignId: campaignId || '',
                    entityId,
                    userId,
                    variation,
                });
                setQuestions?.(res.data.eligibilityCriterias.length);
                let criterias = res?.data?.eligibilityData.map(
                    (criteria: {
                        criteriaType: string;
                        metadata: {
                            title: string;
                            options: string[];
                            isRequired: string;
                            placeholder: string;
                            linkActionName: string;
                            linkActionUrl: string;
                            manualInput: string;
                            keyId?: string;
                            optionsKeyIds?: string[];
                            preventFutureSelection?: boolean;
                            preventPastSelection?: boolean;
                        };
                        criteriaId: string;
                    }) => {
                        return {
                            type: criteria?.criteriaType,
                            question: criteria?.metadata?.title,
                            options: criteria?.metadata?.options || [],
                            criteriaId: criteria?.criteriaId,
                            required: criteria?.metadata?.isRequired,
                            placeholder: criteria?.metadata?.placeholder,
                            keyId: criteria?.metadata?.keyId || "",
                            optionsKeyIds: criteria?.metadata?.optionsKeyIds || [],
                            preventFutureSelection:
                                criteria?.metadata?.preventFutureSelection,
                            preventPastSelection: criteria?.metadata?.preventPastSelection,
                        };
                    }
                );

                setTotalQuestions(res.data.eligibilityCriterias.length);
                if (criterias?.length > 0) {
                    const translatedActionsWithoutOptionsPromise = await quizApi.updateTranslations({
                        criterias,
                        isOption: false,
                        localeCode: localeCode || '',
                        transition
                    });
                    const translatedCriteriaWithOptionsPromise = await quizApi.updateTranslations({
                        criterias,
                        isOption: true,
                        localeCode: localeCode || '',
                        transition
                    });

                    const [
                        translatedActionsWithoutOptions,
                        translatedCriteriaWithOptions,
                    ] = await Promise.all([
                        translatedActionsWithoutOptionsPromise,
                        translatedCriteriaWithOptionsPromise,
                    ]);

                    setFormdata(translatedActionsWithoutOptions);
                    setFormDataSecondary(translatedCriteriaWithOptions);
                } else {
                    setFormdata([]);
                }
            } catch (error) {
                console.error("Error fetching v1 quest data:", error);
                GeneralFunctions.captureSentryException(error);
            }
        }

        // if (isV1Api) {
        //     getQuestDataV1();
        // } else {
        //     getQuestData();
        // }
    }, []);

    const [selectedOptions, setSelectedOptions] = useState<
        Record<string, Array<string>>
    >({});

    const [change, setChange] = useState(true);
    const [checkChange, setCheckChange] = useState(true);

    const [goToNextSection, setGoToNextSection] = useState(false);

    const handleCheckboxChange = (option: string, actionId: string): void => {
        if (selectedOptions[actionId]?.includes(option)) {
            setSelectedOptions((prev) => {
                return {
                    ...prev,
                    [actionId]: prev[actionId].filter((e) => e != option),
                };
            });
        } else {
            if (Array.isArray(selectedOptions[actionId])) {
                selectedOptions[actionId] = [...selectedOptions[actionId], option];
            } else {
                selectedOptions[actionId] = [];
                selectedOptions[actionId] = [...selectedOptions[actionId], option];
            }
        }
        setCheckChange((prev) => !prev);
    };

    const handleRadioChange = (option: string, actionId: string): void => {
        if (answer[actionId]?.includes(option)) {
            setAnswer((prev) => {
                return { ...prev, [actionId]: (prev[actionId] = []) };
            });
        } else {
            answer[actionId] = [];
            answer[actionId] = [...answer[actionId], option];
        }
        setChange((prev) => !prev);
    };

    useEffect(() => {
        const currentQuestion = formdata[currentSection];
        const questionId = currentQuestion?.[newId];
        const isRequired = currentQuestion?.required;
        if (currentQuestion?.type === "USER_INPUT_MULTI_CHOICE") {
            const ansOptions = selectedOptions[questionId];
            if (ansOptions?.length > 0) {
                setGoToNextSection(true);
            } else {
                setGoToNextSection(false);
            }
        } else if (answer[questionId]?.length > 0 && isRequired) {
            setGoToNextSection(true);
        } else {
            setGoToNextSection(false);
        }
    }, [answer, change, checkChange, selectedOptions, formdata, currentSection, formDataOffline]);

    const QuestionArray = [];

    for (let i = 0; i < totalQuestions; i++) {
        QuestionArray.push(
            <div className="gamified-quiz-action-div" key={i}>
                <div className="gamified-quiz-header-ques-title-cont">
                    <div className="question-input-cont">
                        {formdata[i]?.type === "USER_INPUT_SINGLE_CHOICE" ||
                            formdata[i]?.type === "USER_INPUT_MULTI_CHOICE" ? (
                            <div
                                className="question"
                                style={{
                                    fontFamily: themeConfig?.fontFamily,
                                    ...styleConfig?.Question,
                                    color:
                                        styleConfig?.Question?.color || themeConfig?.primaryColor,
                                }}
                            >
                                {formdata[i]?.question}
                                {`${formdata[i]?.required ? "*" : ""}`}
                            </div>
                        ) : null}

                        {formdata[i]?.type === "USER_INPUT_MULTI_CHOICE" ? (
                            <MultiChoice
                                value={formdata[i]}
                                selectedOptions={selectedOptions}
                                handleCheckboxChange={handleCheckboxChange}
                                styleConfig={styleConfig}
                                themeConfig={themeConfig}
                                newId={newId}
                                isV1Api={isV1Api}
                                formDataSecondary={formDataSecondary}
                                questThemeData={questThemeData}
                                optionsHeader={optionsHeader}
                                optionRankFormat={optionRankFormat}
                                unselectedSvg={unselectedSvg}
                                selectedSvg={selectedSvg}
                                optionCheckboxes={optionCheckboxes}
                            />
                        ) : formdata[i]?.type === "USER_INPUT_SINGLE_CHOICE" ? (
                            <SingleChoice
                                value={formdata[i]}
                                handleRadioChange={handleRadioChange}
                                styleConfig={styleConfig}
                                themeConfig={themeConfig}
                                newId={newId}
                                isV1Api={isV1Api}
                                formDataSecondary={formDataSecondary}
                                questThemeData={questThemeData}
                                answer={answer}
                                optionsHeader={optionsHeader}
                                optionRankFormat={optionRankFormat}
                                unselectedSvg={unselectedSvg}
                                selectedSvg={selectedSvg}
                                optionCheckboxes={optionCheckboxes}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        );
    }

    const formSubmitHandler = async () => {
        try {
            const combinedAnswer = { ...answer };
            Object.keys(selectedOptions).forEach((key) => {
                combinedAnswer[key] = selectedOptions[key];
            });

            if (!isV1Api) {
                const actions = Object.keys(combinedAnswer).map((key) => {
                    const formIndex = formdata.findIndex((ele) => ele.actionId === key);
                    return {
                        actionId: key,
                        answers: Array.isArray(combinedAnswer[key]) ? combinedAnswer[key] : [combinedAnswer[key]],
                        question: formdata[formIndex]?.question,
                        expectedAnswer: formdata[formIndex]?.expectedAnswer || [],
                    }
                });

                let summary: any = [];
                const correctQuestionCount = actions.filter((criteria) => {
                    let res = criteria.expectedAnswer?.every((expectedAns) =>
                        criteria.answers.includes(expectedAns)
                    );
                    if (res == true) {
                        summary.push({
                            question: criteria.question,
                            isCorrectAnswer: true,
                        });
                    } else {
                        summary.push({
                            question: criteria.question,
                            isCorrectAnswer: false,
                        });
                    }
                    return res;
                });

                setCorrectQuestions(correctQuestionCount.length);
                setQuizSummary(summary);
                setIsResultPopup(true);
                setExpectedCorrectedAnswers(true);
            } else {
                const criterias = Object.keys(combinedAnswer).map((key) => {
                    const formIndex = formdata.findIndex((ele) => ele.criteriaId === key);
                    return {
                        criteriaId: key,
                        answer: Array.isArray(combinedAnswer[key]) ? combinedAnswer[key] : [combinedAnswer[key]],
                        question: formdata[formIndex]?.question,
                        expectedAnswer: formdata[formIndex]?.expectedAnswer || [],
                    };
                });
                let summary: any = [];
                const correctQuestionCount = criterias.filter((criteria) => {
                    let res = criteria.expectedAnswer?.every((expectedAns) =>
                        criteria.answer.includes(expectedAns)
                    );
                    if (res == true) {
                        summary.push({
                            question: criteria.question,
                            isCorrectAnswer: true,
                        });
                    } else {
                        summary.push({
                            question: criteria.question,
                            isCorrectAnswer: false,
                        });
                    }
                    return res;
                });

                setCorrectQuestions(correctQuestionCount.length);
                setQuizSummary(summary);
                setIsResultPopup(true);
                setExpectedCorrectedAnswers(true);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            GeneralFunctions.captureSentryException(error);
        }
    };

    const handleBackClick = () => {
        setCurrentSection(currentSection - 1);
    }

    const onContinue = () => {
        setIsResultPopup(false);
    }

    const onTryAgain = () => {
        setIsResultPopup(false);
    }

    return (
        <>
            {Quiz ? <div className="q-quiz-cont">
                {isResultPopup ? <ResultPopup totalQuestions={totalQuestions} correctQuestions={correctQuestions} onContinue={onContinue} buttonStyles={styleConfig?.ResultPopupButton} setQuiz={setQuiz} GeneralFunctions={GeneralFunctions} setIsResultPopup={setIsResultPopup} styleConfig={styleConfig} isQuizOverview={isQuizOverview} ResultPopupCloseIcon={ResultPopupCloseIcon} onTryAgain={onTryAgain} isQuizOverviewTitle={isQuizOverviewTitle} questionDetails={quizSummary} expectedCorrectedAnswers={expectedCorrectedAnswers} /> : null}

                <div className="upper-div">
                    <div className="quiz">
                        <div
                            className="quiz-header-section"
                            style={{
                                background:
                                    styleConfig?.Form?.background || themeConfig?.backgroundColor,
                            }}
                        >
                            <div className="div">
                                <div className="quiz-header-task-logo-cont">
                                    <div className="quiz-back-icon" onClick={handleBackClick}>
                                        {isV1Api && currentSection > 0 && BackIcon(IconColor || 'black')}
                                    </div>
                                    <p>
                                        Question <span>
                                            {currentSection + 1}/{totalQuestions}
                                        </span>
                                    </p>
                                    <div className="quiz-close-icon" onClick={onClose}>
                                        {isV1Api && CloseIcon(IconColor || 'black')}
                                    </div>
                                </div>
                                <div className="select-option-cont">
                                    Select an option
                                </div>
                                <div className="question-input-cont">
                                    {formdata[currentSection]?.type ===
                                        "USER_INPUT_SINGLE_CHOICE" ||
                                        formdata[currentSection]?.type ===
                                        "USER_INPUT_MULTI_CHOICE" ? (
                                        <div
                                            className="question"
                                            style={{
                                                color:
                                                    styleConfig?.Question?.color ||
                                                    themeConfig?.primaryColor,
                                                fontFamily: themeConfig?.fontFamily,
                                            }}
                                        >
                                            {formdata[currentSection]?.question}
                                            {`${formdata[currentSection]?.required ? "*" : ""
                                                }`}
                                        </div>
                                    ) : null}
                                    <div className="questionWithBg"></div>
                                </div>
                                <form
                                    className="quiz-header-form"
                                    style={styleConfig?.FormContainer}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div
                                            className="quiz-action-div"
                                        >
                                            <div className="quiz-header-ques-title-cont">
                                                <div className="question-input-cont">
                                                    {/* {formdata[currentSection]?.type ===
                                                            "USER_INPUT_SINGLE_CHOICE" ||
                                                            formdata[currentSection]?.type ===
                                                            "USER_INPUT_MULTI_CHOICE" ? (
                                                            <div
                                                                className="question"
                                                                style={{
                                                                    color:
                                                                        styleConfig?.Question?.color ||
                                                                        themeConfig?.primaryColor,
                                                                    fontFamily: themeConfig?.fontFamily,
                                                                }}
                                                            >
                                                                {formdata[currentSection]?.question}
                                                                {`${formdata[currentSection]?.required ? "*" : ""
                                                                    }`}
                                                            </div>
                                                        ) : null} */}

                                                    {formdata[currentSection]?.type ===
                                                        "USER_INPUT_MULTI_CHOICE" ? (
                                                        <MultiChoice
                                                            value={formdata[currentSection]}
                                                            selectedOptions={selectedOptions}
                                                            handleCheckboxChange={handleCheckboxChange}
                                                            styleConfig={styleConfig}
                                                            themeConfig={themeConfig}
                                                            newId={newId}
                                                            isV1Api={isV1Api}
                                                            formDataSecondary={formDataSecondary}
                                                            questThemeData={questThemeData}
                                                            optionsHeader={optionsHeader}
                                                            optionRankFormat={optionRankFormat}
                                                            unselectedSvg={unselectedSvg}
                                                            selectedSvg={selectedSvg}
                                                            optionCheckboxes={optionCheckboxes}
                                                        />
                                                    ) : formdata[currentSection]?.type ===
                                                        "USER_INPUT_SINGLE_CHOICE" ? (
                                                        <SingleChoice
                                                            value={formdata[currentSection]}
                                                            handleRadioChange={handleRadioChange}
                                                            styleConfig={styleConfig}
                                                            themeConfig={themeConfig}
                                                            newId={newId}
                                                            isV1Api={isV1Api}
                                                            formDataSecondary={formDataSecondary}
                                                            questThemeData={questThemeData}
                                                            answer={answer}
                                                            optionsHeader={optionsHeader}
                                                            optionRankFormat={optionRankFormat}
                                                            unselectedSvg={unselectedSvg}
                                                            selectedSvg={selectedSvg}
                                                            optionCheckboxes={optionCheckboxes}
                                                        />
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {totalQuestions > 0 ? (
                                        <div className="quiz-header-ques-cancel-next">
                                            <button
                                                onClick={() => {
                                                    if (currentSection > 0) {
                                                        setCurrentSection(currentSection - 1);
                                                        GeneralFunctions.fireTrackingEvent(
                                                            "quest_quiz_previous_section_button_clicked",
                                                            "quiz"
                                                        );
                                                    } else {
                                                        setQuiz(false);
                                                        GeneralFunctions.fireTrackingEvent(
                                                            "quest_quiz_cancel_button_clicked",
                                                            "quiz"
                                                        );
                                                    }
                                                }}
                                                type="button"
                                                className="cancel-btn"
                                                style={{
                                                    background:
                                                        styleConfig?.SecondaryButton?.background ||
                                                        "var(--Neutral-White-100, #FFF)",
                                                    color:
                                                        styleConfig?.SecondaryButton?.color ||
                                                        "var(--Neutral-Black-400, #2C2C2C)",
                                                    fontFamily: themeConfig?.fontFamily,
                                                    borderColor:
                                                        styleConfig?.SecondaryButton?.borderColor,
                                                }}
                                            >
                                                {currentSection > 0 ? "Previous" : "Cancel"}
                                            </button>

                                            <PrimaryButton
                                                type={"button"}
                                                onClick={() => {
                                                    if (currentSection < totalQuestions - 1) {
                                                        GeneralFunctions.fireTrackingEvent(
                                                            "quest_quiz_next_section_button_clicked",
                                                            "quiz"
                                                        );
                                                        setCurrentSection(currentSection + 1);
                                                    } else if (currentSection >= totalQuestions - 1) {
                                                        formSubmitHandler();
                                                    }
                                                }}
                                                disabled={!goToNextSection}
                                                className="q-onb-main-btn2"
                                                style={{
                                                    font: "",
                                                    fontFamily: "Figtree",
                                                    background:
                                                        styleConfig?.PrimaryButton?.background ||
                                                        themeConfig?.buttonColor ||
                                                        "linear-gradient(84deg, #9035FF 0.36%, #0065FF 100.36%)",
                                                    color:
                                                        styleConfig?.PrimaryButton?.color ||
                                                        "var(--Neutral-White-100, #FFF)",

                                                    border: `1.5px solid ${styleConfig?.PrimaryButton?.borderColor
                                                        ? styleConfig?.PrimaryButton?.borderColor
                                                        : themeConfig?.buttonColor
                                                            ? themeConfig?.buttonColor
                                                            : "#D1ACFF"
                                                        }`,
                                                    fontStyle: "normal",
                                                    fontWeight: "600",
                                                    lineHeight: "20px",
                                                }}
                                            >
                                                {currentSection >= totalQuestions - 1 ? isV1Api ? translatedData.length > 0 ? translatedButton : "Submit" : "Submit" : "Next"}
                                            </PrimaryButton>
                                        </div>
                                    ) : null}
                                </form>
                            </div>
                        </div>

                        {showFooter ? (
                            <div
                                className="quiz-footer-section"
                                style={styleConfig?.Footer}
                                onClick={() =>
                                    window.open(
                                        footerLink ? footerLink : "https://www.plgos.com/",
                                        "_blank"
                                    )
                                }
                            >
                                <div
                                    className="footer-content"
                                    style={{
                                        color:
                                            styleConfig?.Footer?.color || themeConfig?.secondaryColor,
                                        fontFamily: themeConfig?.fontFamily,
                                    }}
                                >
                                    {footerText || "Powered by PLG OS"}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div> : null}
        </>
    )
}

export default Quiz;